module.exports = __webpack_public_path__ + "static/media/banner.0b8c5129.svg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/banner.svg
// module id = 186
// module chunks = 0